import React from "react"
import _ from "lodash";

export default ({item, group}) =>
  <h1 className="product-name">{titleString(item, group)}</h1>

// グループ商品の場合は、グループ名を表示
export const titleString = (item, group) =>
  _.get(group, "groupName", _.get(item, "Title", ""))